module.exports = __webpack_public_path__ + "img/visit.cfb84571.png";